import "core-js/modules/es.parse-int.js";
import moment from "moment-timezone";
export default {
  name: "LaunchMaintenanceDrawer",
  data: function data() {
    return {
      selectedMaintenanceId: null,
      drawer: false,
      duration: null,
      durationUnit: "minutes",
      durationUnits: [{
        id: "minutes",
        label: "Minutes"
      }, {
        id: "hours",
        label: "Hours"
      }]
    };
  },
  computed: {
    maintenanceMode: {
      get: function get() {
        return this.$maintenanceMode.isActive;
      },
      set: function set(data) {
        this.$maintenanceMode.set(data.value, data.expirationDate);
      }
    }
  },
  methods: {
    openDrawer: function openDrawer(id, duration) {
      this.selectedMaintenanceId = id;
      this.duration = duration;
      this.drawer = true;
    },
    closeDrawer: function closeDrawer() {
      this.drawer = false;
    },
    launchMaintenance: function launchMaintenance() {
      if (!this.duration) return;
      var nowUTC = moment.utc();
      var durationInMinutes = this.durationUnit === "hours" ? parseInt(this.duration) * 60 : parseInt(this.duration);
      var expirationDateUTC = nowUTC.clone().add(durationInMinutes, "minutes");
      var startTime = nowUTC.format("YYYY-MM-DDTHH:mm:00Z");
      var expirationDate = expirationDateUTC.format("YYYY-MM-DDTHH:mm:00Z");
      this.$maintenanceMode.activate(expirationDate, startTime, this.selectedMaintenanceId);
      if (this.selectedMaintenanceId) {
        this.$maintenanceMode.archiveScheduledMaintenance(this.selectedMaintenanceId);
      }
      this.$emit("closed");
      this.closeDrawer();
    }
  }
};